import React from 'react';
import { ListHeader, PartnerFundsSummary } from 'components';
import { jsx as ___EmotionJSX } from "@emotion/react";

var PartnerCashDeskSummary = function PartnerCashDeskSummary() {
  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0441\u043A\u0430 \u043A\u0430\u0441\u0430"
  }), ___EmotionJSX(PartnerFundsSummary, null));
};

export default PartnerCashDeskSummary;